import angular from 'angular';
import dspJsTracker from './js_tracker.directive';
import customEngagementButton from './custom_engagement_button.directive';

import './ad_markup/module';
import './beacons/module';
import './rtb_pixel/module';

angular.module('generator.dsp', [
  'generator.creativePreview',
  'generator.dsp.adMarkup',
  'generator.dsp.beacons',
  'generator.dsp.rtbPixel'
]);

angular
  .module('generator.dsp')
  .directive('dspJsTracker', dspJsTracker)
  .directive('customEngagementButton', customEngagementButton);
